import React from 'react';

const CtaArrowIcon: React.FC = () => (
  <svg
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1 1L7.36396 7.36396L1 13.7279"
      stroke="#131212"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default CtaArrowIcon;
